<template>
  <v-menu offset-y left :close-on-content-click="false">
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        v-on="on"
        v-if="documentExists || documentsNumber"
        @click.stop.prevent="getItems"
      >
        <display-icon-badge-tooltip
          :badge-number="documentsNumber"
          icon="mdi-file"
          tooltip-text="Documents liés"
          class="mr-2"
        />
      </v-btn>
    </template>
    <v-list v-if="items.length">
      <v-list-item v-for="item in items" :key="item.id" @click="download(item)">
        <v-list-item-title v-if="downloading === item.id">
          <v-progress-circular
            indeterminate
            size="20"
            width="2"
            color="light-blue"
          ></v-progress-circular>
        </v-list-item-title>
        <v-list-item-title v-else>{{ item.title }}</v-list-item-title>
      </v-list-item>
      <v-list-item v-if="hasMore > 0">
        <v-list-item-title>et {{ hasMore }} autres</v-list-item-title>
      </v-list-item>
    </v-list>
    <v-list v-else>
      <v-list-item>
        <v-list-item-title>
          {{
            isLoading
              ? 'Chargement des documents ...'
              : "Aucun document n'a été retrouvé."
          }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { generateMessage } from '@/utils/i18n';
import { getDocuments } from '@/services/services/documentsService';
import DisplayIconBadgeTooltip from '@/components/displays/DisplayIconBadgeTooltip';
import downloadDocument from '@/pages/property/documents/downloadDocument';

export default {
  name: 'DocumentsMenu',
  components: { DisplayIconBadgeTooltip },
  mixins: [downloadDocument],
  props: {
    documentsNumber: {
      type: Number,
      required: false,
    },
    documentExists: {
      type: Boolean,
      required: false,
    },
    propertyId: {
      type: Number,
      required: true,
    },
    actionId: {
      type: Number,
      required: true,
    },
    maxImages: {
      type: Number,
      required: false,
      default: 10,
    },
  },
  data() {
    return {
      isLoading: false,
      items: [],
      hasMore: 0,
    };
  },
  methods: {
    generateMessage,
    getItems() {
      const params = {
        pageIndex: 0,
        pageSize: this.maxImages,
        orderByText: 'last_update_datetime desc',
        propertyId: this.propertyId,
        actionId: this.actionId,
      };
      this.isLoading = true;
      getDocuments(params)
        .then((result) => {
          this.items = result.documents;
          this.hasMore = result.count - this.maxImages;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getImage(item) {
      this.currentLoading = item.id;
      this.download(item);
    },
  },
};
</script>
